<template>
  <van-popup v-model:show="innerShow" position="bottom" round closeable :style="{ height: '95%' }">
    <div class="flex flex-col h-full bg-white">
      <PopupTitle class="bg-white" title="评价" />
      <div class="flex-1 overflow-hidden overflow-y-scroll p-15">
        <div class="rounded-6 overflow-hidden" style="border: 1px solid #ccd3df">
          <van-field
            v-model="formData.praise_notes"
            rows="8"
            autosize
            label=""
            type="textarea"
            placeholder="请输入评价内容"
          />
        </div>

        <div class="mt-15">
          <van-uploader
            accept="image/*"
            v-model="formData.praise_pic"
            multiple
            :max-count="9"
            :after-read="uploadMedia"
            :before-read="beforeRead"
          />
          <div class="h-50 flex items-center text-default text-16">
            响应速度
            <van-rate class="ml-25" v-model="formData.speed_result" :size="25" color="#FFB62F" />
          </div>
          <div class="h-50 flex items-center text-default text-16">
            服务态度
            <van-rate class="ml-25" v-model="formData.serve_result" :size="25" color="#FFB62F" />
          </div>
          <div class="h-50 flex items-center text-default text-16">
            服务质量
            <van-rate class="ml-25" v-model="formData.professional_result" :size="25" color="#FFB62F" />
          </div>
        </div>
      </div>
      <FooterButton :showCancel="false" okText="提交" @submit="onConfirm" />
    </div>
  </van-popup>
</template>

<script setup>
import { reactive } from "vue";
import { useVModel } from "@vueuse/core";
import { repairService } from "@/service";
import to from "await-to-js";
import { Toast } from "vant";
import PopupTitle from "@/components/PopupPicker/PopupTitle.vue";
import { FooterButton } from "@/components/FormView/index";
import { useRoute } from "vue-router";

const props = defineProps({
  show: { default: false }
});

const route = useRoute();

const emit = defineEmits(["update:show", "confirm"]);

const innerShow = useVModel(props, "show", emit);

const formData = reactive({
  praise_notes: "",
  serve_result: 5,
  speed_result: 5,
  professional_result: 5,
  praise_pic: []
});

const beforeRead = async file => {
  if (file.type.includes("video")) {
    return new Promise((resolve, reject) => {
      Toast("暂不支持上传视频");
      reject();
    });
  }
};

// 上传图片视频
const uploadMedia = file => {
  const files = [].concat(file);
  files.forEach(async file => {
    const formData = new FormData();
    formData.append("my_files", file.file);
    file.status = "uploading";
    file.message = "上传中...";
    const [error, data] = await to(repairService.saveImg(formData));
    if (error) {
      file.status = "failed";
      file.message = "上传失败";
      return;
    }
    file.status = "done";
    file.message = "上传成功";
    file.res = data.data.data[0];
  });
};

const onConfirm = async () => {
  const [err] = await to(
    repairService.addPraise({
      workorder_id: route.query.id,
      praise_notes: formData.praise_notes,
      serve_result: formData.serve_result,
      speed_result: formData.speed_result,
      professional_result: formData.professional_result,
      praise_pic: formData.praise_pic.map(item => item.res.id).toString()
    })
  );

  if (err) return;

  Toast.success("评价成功！");

  innerShow.value = false;

  emit("refresh");
};
</script>
